import { rest } from "common/api-client/rest";
import apiURL from "common/config/api-url.config";
import type { UserInfoResponse } from "common/context/auth/token-validation";
import type { Result } from "common/utils/result";

type SubmitLoginResponse =
  | (UserInfoResponse & { validation: true })
  | { validation: false; message?: string };

export type SubmitLoginParams = {
  userId: string;
  password?: string;
  msalResponse?: string | undefined;
};

export async function submitLoginRequest({
  userId,
  password = "",
  msalResponse,
}: SubmitLoginParams): Promise<Result<UserInfoResponse>> {
  const result = await rest<SubmitLoginResponse>("auth/login", {
    baseURL: apiURL,
    body: {
      userId,
      password,
      ...(msalResponse === undefined ? {} : { msalResponse }),
    },
  });

  if (result instanceof Error) {
    return result;
  }
  if (result.kind === "empty") {
    return new Error("Response does not have a body");
  }
  if (!result.body.validation) {
    return new Error(`Validation failed: ${result.body.message}`);
  }

  return result.body;
}
